import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Order } from "../../../../services";
import { requestErrorDisplay } from "../../../../utils";
import CustomButton from "../../../custom/custom-button/CustomButton";
import CustomTextarea from "../../../custom/custom-textarea/CustomTextarea";
import CloseIconNew from "../../../shared/icons/CloseIconNew";
import style from "../../../order/info/confirmModal.module.scss";

const ReturnToTenderModal = ({ item, onClose, onSuccess, onSubmit = Order.updateStatus }) => {
  const { t } = useTranslation();
  const isAuction = item?.assignmentMethod === "Auction";

  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = () => {
    if (isLoading) return;
    if (!comment.trim()) {
      const message = t("orderInfoClient.moreMenu.returnToTenderReasonRequired");
      setError(message);
      toast.error(message);
      return;
    }
    setError("");

    setIsLoading(true);
    onSubmit(item.id, "returnToTender", comment.trim())
      .then(() => {
        setError("");
        onClose();
        onSuccess?.();
        toast.success(t("orderInfoClient.moreMenu.returnToTenderSuccess"));
      })
      .catch((err) => {
        requestErrorDisplay(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return ReactDOM.createPortal(
    <div className={style.modalOverlay} data-portal-modal="true">
      <div className={style.modalContainer} style={{width: "500px"}}>
        <div className={style.topbar}>
          <h2 className={style.modalTitle}>
            {t(
              isAuction
                ? "orderInfoClient.moreMenu.returnToAuctionTitle"
                : "orderInfoClient.moreMenu.returnToTenderTitle",
            )}
          </h2>
          <button
            type="button"
            className={style.closeBtn}
            onClick={onClose}
            aria-label={t("common.cancel")}
          >
            <CloseIconNew />
          </button>
        </div>

        <p className={style.modalDescription}>{t("orderInfoClient.moreMenu.returnToTenderDescription")}</p>

        <div className={style.card}>
          <CustomTextarea
            labelText={t("orderInfoClient.moreMenu.returnToTenderReasonLabel")}
            placeholder={t("orderInfoClient.moreMenu.returnToTenderReasonPlaceholder")}
            isBgGray
            rows={2}
            errorText={!comment.trim() && error}
            inputType="text"
            value={comment}
            onChangeValue={(value) => {
              setComment(value);
              if (value) setError("");
            }}
          />
        </div>

        <div className={style.modalActions}>
          <CustomButton
            isCancel
            text={t("common.cancel")}
            onClick={onClose}
            disabled={isLoading}
          />
          <CustomButton
            isNavy
            text={t(
              isAuction
                ? "orderInfoClient.moreMenu.returnToAuctionSubmit"
                : "orderInfoClient.moreMenu.returnToTenderSubmit",
            )}
            onClick={handleSubmit}
            isLoading={isLoading}
            disabled={isLoading}
          />
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ReturnToTenderModal;
